module.exports = __webpack_public_path__ + "img/info-icon-white.36176709.svg";